import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { withStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
const Text = withStyles({
  root: {
    color: '#ffffff',
    fontSize: '12px',
  },
})(Typography);

const CustomButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
  alignItems: 'center',
}));

interface horizontalStatusButtonProps {
  type?: string;
  text: string;
}
const HorizontalStatusButton: React.FC<horizontalStatusButtonProps> = ({
  type,
  text,
}) => {
  return (
    <CustomButton>
      {type === 'favor-filled' ? (
        <FavoriteIcon style={{ fontSize: '35px', color: '#ffffff' }} />
      ) : type === 'favor' ? (
        <FavoriteBorderIcon style={{ fontSize: '35px', color: '#ffffff' }} />
      ) : type === 'commit' ? (
        <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: '2rem' }} />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.711"
          height="24"
          viewBox="0 0 17.711 24"
        >
          <path
            id="Icon_metro-bitcoin"
            data-name="Icon metro-bitcoin"
            d="M23.3,11.484a3.276,3.276,0,0,1-1.811,3.566,4.151,4.151,0,0,1,2.419,1.424,4.1,4.1,0,0,1,.622,2.958,5.226,5.226,0,0,1-.449,1.728,3.814,3.814,0,0,1-.892,1.23,4.537,4.537,0,0,1-1.341.809,8.169,8.169,0,0,1-1.679.477,16.655,16.655,0,0,1-2.011.207v3.525H16.034V23.938q-1.106,0-1.686-.014v3.483H12.219V23.882q-.249,0-.746-.007t-.76-.007H7.948l.428-2.529H9.911a.738.738,0,0,0,.8-.7V15.078h.221a1.406,1.406,0,0,0-.221-.014V11.1a1.1,1.1,0,0,0-1.23-.94H7.948V7.89l2.93.014q.885,0,1.341-.014V4.407h2.129V7.821q1.133-.028,1.686-.028V4.407h2.129V7.89A12.332,12.332,0,0,1,20.1,8.2a6.286,6.286,0,0,1,1.562.622A3.166,3.166,0,0,1,22.8,9.9a3.527,3.527,0,0,1,.5,1.583Zm-2.972,7.533a1.844,1.844,0,0,0-.207-.885,2.072,2.072,0,0,0-.511-.636,2.625,2.625,0,0,0-.795-.422,6.71,6.71,0,0,0-.905-.256,8.173,8.173,0,0,0-1.023-.124q-.608-.041-.954-.041t-.892.014q-.546.014-.657.014v4.672l.511.007q.4.007.663.007t.733-.021q.47-.021.809-.055t.788-.117a5.291,5.291,0,0,0,.767-.194,4.7,4.7,0,0,0,.657-.29,1.915,1.915,0,0,0,.546-.415,1.954,1.954,0,0,0,.339-.553,1.832,1.832,0,0,0,.131-.7Zm-.981-6.579a1.814,1.814,0,0,0-.173-.809,1.926,1.926,0,0,0-.422-.581,2.067,2.067,0,0,0-.663-.387,4.751,4.751,0,0,0-.76-.228,7.611,7.611,0,0,0-.85-.111q-.5-.041-.8-.035l-.746.014-.546.007v4.243l.477.007q.408.007.643,0t.691-.028c.3-.014.76-.076.76-.076s.44-.088.712-.152a2.344,2.344,0,0,0,.67-.256,3.8,3.8,0,0,0,.511-.373,1.33,1.33,0,0,0,.373-.532,1.917,1.917,0,0,0,.124-.7Z"
            transform="translate(-7.356 -3.907)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </svg>
      )}
      <Text>{text}</Text>
    </CustomButton>
  );
};

export default HorizontalStatusButton;
